import { Vue } from 'vue-property-decorator';

export class TenantSettingsSerializer extends Vue {

    public static INSTANCE = new TenantSettingsSerializer();

    static get instance() {
        return this.INSTANCE;
    }

    /**
     * serializeTenantSettings
     */
    public serializeActiveTenantSettings(payload: any) {
        return payload ? payload.tenant_settings : {};
    }
}

export const tenantSettingsSerializer = TenantSettingsSerializer.instance;
